import { Card, Col, Row } from "react-bootstrap";
import HippoTable from "components/ReactTable/HipposReactTable";
import { useContext, useEffect, useState } from "react";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import ShowModalButton from "views/Components/ShowModalButton";
import TimestampColumn from "components/Custom/TimestampColumn";
import DateRangeContext from "contexts/DateRangeContext";
import TableHistoryModal from "components/Modals/TableHistoryModal";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function TablesHistoryTable() {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [orders, setOrders] = useState([]);
  const [show, setShow] = useState(false);
  const [tbh, setTbh] = useState(null);
  const [tableHistoryId, setTableHistoryId] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  const handleClose = () => setShow(false);

  const handleShow = (tbh) => {
    setTbh(tbh);
    setTableHistoryId(tbh.localId);
    setShow(true);
  };

  const columns = [
    {
      Header: t("tables.headers.table"),
      accessor: "tableName",
      minWidth: 100,
      maxWidth: 100,
      width: 100,
    },
    {
      Header: t("tables.headers.status"),
      accessor: "status",
      minWidth: 75,
      maxWidth: 75,
      width: 75,
    },
    {
      Header: t("tables.headers.openedAt"),
      accessor: "localCreatedAt",
      minWidth: 200,
      maxWidth: 400,
      width: 500,
    },
    {
      Header: t("tables.headers.closedAt"),
      accessor: "localClosedAt",
      minWidth: 200,
      maxWidth: 400,
      width: 500,
    },
    {
      Header: "",
      accessor: "actions",
      maxWidth: 80,
      minWidth: 30,
      width: 60,
    },
  ];

  const getData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/table-history/store/${storeId}`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        attachCustom(resp);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.userName = el.storeUser ? el.storeUser.name : "";
      el.tableName = el.table ? el.table.name : "";
      el.status =
        el.closedAt == null ? (
          <i title={t("tables.headers.open")} className="nc-icon nc-button-play text-success icon-bold"></i>
        ) : (
          <i title={t("tables.headers.closed")} className="nc-icon nc-button-pause text-danger icon-bold"></i>
        );

      el.localCreatedAt = <TimestampColumn timestamp={el.localCreatedAt} />;
      el.localClosedAt = el.closedAt ? <TimestampColumn timestamp={el.closedAt} /> : "";
      el.actions = <ShowModalButton handler={() => handleShow(el)} variant="warning" icon="fa fa-list-ul" className="text-warning btn-link" title={t("common.actions.viewProducts")} />;
      return el;
    });

    setOrders(enhanced);
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    getData();
  }, [storeId, dateRange]);

  return (
    <>
      <TableHistoryModal tableName={tbh?.table?.name} people={tbh?.people} user={tbh?.storeUser?.name} tableHistoryId={tableHistoryId} show={show} handleClose={handleClose} />
      <Card className="strpied-tabled-with-hover">
        <Card.Header>
          <Row>
            <Col>
              <Card.Title as="h4">{t("common.labels.tableHistory")}</Card.Title>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <p className="card-category">{t(
                "messages.restaurantHistoryForThePeriodDefinedByTheSelectedDatesPrefix",
              )}</p>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="table-responsive p-0">
          {showLoader ? (
            <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
              <ClipLoader size={50} color={"#ff6fbc"} />
            </div>
          ) : (
            <Col>
              <HippoTable data={orders} columns={columns} className="-striped -highlight primary-pagination" />
            </Col>
          )}
        </Card.Body>
        <Card.Footer>
          <div className="mb-1"></div>
        </Card.Footer>
      </Card>
    </>
  );
}

export default TablesHistoryTable;
